import { Link } from "react-router-dom";

const Signup2 = ({handlePage}) => {
    return(<>

<div className="font-hk flex flex-col justify-center items-center h-screen bg-black bg-opacity-70">
  <div className="relative flex flex-col items-center bg-white p-8 rounded-lg shadow-lg justify-around w-[95vw]  md:w-[44vw] md:h-[60vh]">
  <button className="absolute z-[110] top-3 right-3 text-[30px]" onClick={()=>{handlePage(-1)}}><i className=" fa-regular fa-circle-xmark"></i></button>
    <h1 className="text-3xl font-bold mb-4 text-gray-800">Thanks for Registering</h1>
    <h2 className="text-lg font-medium mb-2 text-gray-800 text-center">We have sent you a Verification Link on your email address</h2>
    <h3 className="text-base font-medium mb-4 text-gray-500">Open Link to activate your account</h3>
    
        
    <div className="w-full" onClick={()=>handlePage(-1)}>
    <button type="submit" className="bg-black  text-white px-4 py-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 w-full mb-4">
        OK
        </button>
        </div>
        
    <a href="#" className="text-sm text-blue-500 hover:text-blue-700">Resend Code</a>
    <a href="#" onClick={()=>handlePage(0)} className="text-sm text-blue-500 hover:text-blue-700 mt-4">Login</a>
  </div>
</div>

    </>)}

export default Signup2;